window.OKJS = window.OKJS || {};
(function (OKJS) {
    OKJS.Survey = {

        settings: {


        },

        init: function () {
            var s = this.settings;
            
            this.setupSurveyNavigation();
            this.setupKundeservicePanel();
            this.setupSurveys();
        },

        createSurveyStepper: function (surveyStep, clickedButton) {
            return function (e) {
                if (e) {
                    e.preventDefault();
                }

                var surveyWrap = surveyStep.parentElement,
                    stepId = clickedButton.dataset.surveyStep,
                    nextStep = surveyWrap.querySelector(stepId);
                
                if (!stepId) return;

                if (stepId.indexOf("survey__step--callme") > -1) {
                    dtmLayer.form = {
                        name: "Ring mig op",
                        event: "Form started"                            
                    };

                    if (_satellite && _satellite.track) {
                        _satellite.track("generic form event");
                    } 
                }

                surveyStep.classList.remove("survey__step--active");
                setTimeout(function () {
                    nextStep.classList.add("survey__step--active");
                }, 150);
            };
        },

        formHandler: function (form, validator, then) {
            var action = form.action;
            var method = form.method;
            return function (e) {
                e.preventDefault();

                if (!action || !method) {
                    return;
                }

                if (validator && !validator()) {
                    return false;
                }

                var request = new XMLHttpRequest();
                request.open(method, action);
                var data = new FormData(form);
                request.send(data);

                if (then) {
                    then();
                }
            };
        },
        analyticsHandler: function (answer) {
            return function () {
                dtmLayer.event = {
                    faqAnswerQuestion: answer
                };
                if (_satellite && _satellite.track) {
                    _satellite.track("faq survey sent");
                }
            };
        },

        callMeFormHandler: function (form, validator, then) {
            var action = form.action;
            var method = form.method;
            return function (e) {
                e.preventDefault();

                if (!action || !method) {
                    return;
                }

                if (validator && !validator()) {
                    dtmLayer.form = {
                        name: "Ring mig op",
                        event: "Form error",
                        error_message: "Du skal indtaste et gyldigt telefonnummer"
                    };
                    if (_satellite && _satellite.track) {
                        _satellite.track("generic form event");
                    }

                    return false;
                }

                var request = new XMLHttpRequest();
                request.open(method, action);

                request.onreadystatechange = function () {
                    if (this.readyState === XMLHttpRequest.DONE) {
                        if (this.status === 200) {

                            dtmLayer.form = {
                                name: "Ring mig op",
                                event: "Form completed"
                            };
                            if (_satellite && _satellite.track) {
                                _satellite.track("generic form event");
                            }


                            if (then) {
                                then();
                            }
                        } else {
                            dtmLayer.form = {
                                name: "Ring mig op",
                                event: "Form error",
                                error_message: "Server error"
                            };
                            if (_satellite && _satellite.track) {
                                _satellite.track("generic form event");
                            }
                        }
                    }
                };

                var data = new FormData(form);
                request.send(data);

                if (then) {
                    then();
                }
            };
        },


        setupSurveyNavigation: function () {
            var surveySteps = document.querySelectorAll(".survey__step:not(.survey__step--manual)");
            for (var i = 0; i < surveySteps.length; i++) {
                var surveyStep = surveySteps[i];
                var surveyButtons = surveyStep.querySelectorAll("button:not(.btn--red)");
                if (surveyButtons.length > 0) {
                    for (var j = 0; j < surveyButtons.length; j++) {
                        surveyButtons[j].addEventListener("click", OKJS.Survey.createSurveyStepper(surveyStep, surveyButtons[j]));
                    };
                }
            }
        },

        //kundeservice panel
        setupKundeservicePanel: function () {
            var kundeserviceForms = document.querySelectorAll(".js-customerservice .survey__step--callme form");
            for (var i = 0; i < kundeserviceForms.length; i++) {
                var form = kundeserviceForms[i];
                var validator = OKJS.Validation.addValidation(form, 'phoneNumber', 'tel', function (value) {
                    return (value || '').length === 8;
                });

                var callmeSubmitButton = form.querySelector("button[type='submit']"), handler = OKJS.Survey.callMeFormHandler(form, validator, OKJS.Survey.createSurveyStepper(form.parentElement, callmeSubmitButton));
                var inputFields = form.querySelectorAll('input');                
                inputFields.forEach(function (item) {
                    item.addEventListener('focus', function () {
                        if (!item.getAttribute('data-first-click')) {
                            dtmLayer.form = {
                                name: "Ring mig op",
                                input_field: item.name,
                                event: "Input field clicked"
                            };

                            if (_satellite && _satellite.track) {
                                _satellite.track("generic form event");
                            }
                            
                            item.setAttribute('data-first-click','true');
                        }
                    });
                });

                form.addEventListener("submit", handler);
                callmeSubmitButton.addEventListener("click", handler);
            }
        },

        //grey/white survey ('var siden nyttig?') + feedback
        setupSurveys: function () {
            var surveys = document.querySelectorAll(".survey--grey,.survey--white");
            for (var i = 0; i < surveys.length; i++) {
                var survey = surveys[i];

                var rememberAnswer = survey.querySelector(".remember--answer");
                if (rememberAnswer) {
                    var rememberAnswerButtons = rememberAnswer.querySelectorAll("button");
                    var rememberAnswerCookieName = rememberAnswer.dataset.surveycookie;
                    var rememberPageId = rememberAnswer.dataset.pageid;
                    var rememberSurveyId = rememberAnswer.dataset.surveyid;

                    for (var b = 0; b < rememberAnswerButtons.length; b++) {
                        var btn = rememberAnswerButtons[b];
                        btn.addEventListener("click", function () {
                            var date = new Date();
                            date.setMonth(date.getMonth() + 6);

                            var json = OKJS.Global.parseJson(OKJS.Global.readCookieString(rememberAnswerCookieName)) || [];
                            if (json.length > 19) {
                                json.shift();
                            }
                            json.push([rememberPageId, rememberSurveyId]);

                            document.cookie = rememberAnswerCookieName + "=" + JSON.stringify(json) + ";path=/;expires=" + date.toUTCString();
                        });
                    }
                }

                var surveyFeedbackForm = survey.querySelector(".survey__step--no form");
                surveyFeedbackForm.addEventListener("submit", OKJS.Survey.formHandler(surveyFeedbackForm));
                surveyFeedbackForm.querySelector("button[type='submit']").addEventListener("click", OKJS.Survey.formHandler(surveyFeedbackForm));

                var surveyQuestion = survey.querySelector(".survey__step--question");
                surveyQuestion.querySelector("button[data-value='yes']").addEventListener("click", OKJS.Survey.analyticsHandler("Yes"));
                surveyQuestion.querySelector("button[data-value='no']").addEventListener("click", OKJS.Survey.analyticsHandler("No"));
            }
        }
    };

}(window.OKJS));
